// extracted by mini-css-extract-plugin
module.exports = {"root":"hliL_","grid":"_38-Wy","bold":"QRxiG","emptyAttribute":"_1MUga"};